/** Base URL for `/auth/sso/*` (API v1). */
export function getSsoApiBaseUrl() {
  const explicit = process.env.REACT_APP_SSO_API_BASE_URL;
  if (explicit) {
    return String(explicit).replace(/\/+$/, "");
  }

  const v2 = String(process.env.REACT_APP_API_URL_V2 ?? "").replace(/\/+$/, "");
  if (v2) {
    if (/\/api\/v2$/i.test(v2)) {
      return v2.replace(/\/api\/v2$/i, "/api/v1");
    }
    return v2;
  }

  return String(process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");
}

export const SSO_APPLICATION = "frontend";

export function buildSsoChallengePath(providerKey) {
  if (!providerKey) return "";
  return `auth/sso/${encodeURIComponent(providerKey)}/challenge`;
}

export function buildSsoChallengeUrl(providerKey, query = {}) {
  const base = getSsoApiBaseUrl();
  if (!base || !providerKey) return "";
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value != null && String(value).trim() !== "") {
      params.set(key, String(value));
    }
  });
  const queryString = params.toString();
  const path = buildSsoChallengePath(providerKey);
  return `${base}/${path}${queryString ? `?${queryString}` : ""}`;
}
